import { render, staticRenderFns } from "./CustomerGroupsAlias.vue?vue&type=template&id=659ef6a3&"
import script from "./CustomerGroupsAlias.vue?vue&type=script&lang=ts&"
export * from "./CustomerGroupsAlias.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports